import _ from "lodash";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

const Pagination = ({ itemsCount, pageSize, currentPage, onPageChange }) => {
  const pages_count = Math.ceil(itemsCount / pageSize);
  const display_limit = 2;

  if (pages_count === 1) return null;

  let limited_pages;

  if (pages_count <= display_limit * 2 + 1) {
    limited_pages = _.range(1, pages_count + 1);
  } else {
    const start_page = Math.max(currentPage - display_limit, 1);
    const end_page = Math.min(currentPage + display_limit, pages_count);

    limited_pages = [];

    limited_pages.push(..._.range(start_page, end_page + 1));

    if (end_page < pages_count) {
      limited_pages.push("...", pages_count);
    }
  }

  return (
    <div className="flex items-center justify-between">
      <div></div>
      <nav
        className="relative inline-flex rounded-md -space-x-px"
        aria-label="Pagination"
      >
        <button
          className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-400 hover:bg-gray-50"
          disabled={currentPage <= 1}
          onClick={() => {
            onPageChange(currentPage - 1);
          }}
        >
          <IoChevronBack />
        </button>
        {limited_pages.map((page) => (
          <button
            key={page}
            className={`text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
              page === currentPage
                ? "bg-blue-100 border-blue-400 z-10"
                : "bg-white border-gray-300"
            }`}
            disabled={typeof page === "string"}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ))}
        <button
          className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-400 hover:bg-gray-50"
          disabled={currentPage >= pages_count}
          onClick={() => {
            onPageChange(currentPage + 1);
          }}
        >
          <IoChevronForward />
        </button>
      </nav>
    </div>
  );
};

export default Pagination;
